<template>
  <div class="peoples">
    <div
      v-for="(people, index3) in peoples"
      :key="index3"
      class="people flex align-center"
    >
      <div class="header-container" v-if="showHeader">
        <img :src="people.realPath | imgFilter" v-if="people.realPath" />
        <img src="../../../assets/images/default-header.png" v-else />
      </div>
      <div class="info flex flex-direction align-start justify-around">
        <div class="name">
          <span :class="{ between: people.name.length < 3 }">{{
            people.name
          }}</span>
        </div>
        <div
          class="postiton"
          v-html="handleBr(people.enterprise + people.duty)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "Speaker",
  props: {
    //演讲者列表列表
    peoples: {
      type: Array,
      default: function () {
        return [];
      },
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  filters: {
    imgFilter(imgUrl) {
      let new_imgUrl = "";
      if (imgUrl) {
        new_imgUrl = imgUrl.replace(
          /^.*\/\/hwyhw.smarket.net.cn/,
          "https://hwyhw-files.smarket.net.cn"
        );
      }
      return new_imgUrl;
    },
  },
  methods: {
    handleBr(str) {
      if (this.$store.state.isMobile) {
        return str;
      } else {
        return str;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  .peoples {
    padding: 10px 0;
    .people {
      margin: 10px 0;
      .info {
        //width: 293px;
        font-size: 16px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #666666;
        line-height: 24px;
        .name {
          color: #666666;
          .between {
            display: inline-block;
            width: 3em;
            text-align-last: justify;
          }
        }
        .postiton {
          font-size: 14px;
          overflow: hidden;
          color: #999999;
          line-height: 24px;
        }
      }
    }
  }
  .header-container {
    width: 60px;
    height: 60px;
    overflow: hidden;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    margin-right: 22px;
    img {
      width: 60px;
    }
  }
}
@media (max-width: 992px) {
  .peoples {
    padding-bottom: 12px;
    margin-left: 42px;
    margin-top: 2px;
    .people {
      .header-container {
        width: 80px;
        height: 80px;
        overflow: hidden;
        flex-shrink: 0;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 22px;
        img {
          width: 80px;
        }
      }

      .info {
        //width: 293px;
        font-size: 24px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #666666;
        line-height: 34px;
        .name {
          font-size: 24px;
          color: #666666;
        }
        .postiton {
          font-size: 22px;
          color: #999999;
        }
      }
    }
  }
}
</style>
